// Suspense fallback for lazy-loaded routes — deliberately minimal rather
// than a spinner graphic, since it's often on screen for a single frame
// while a route chunk downloads.
export default function PageLoading() {
  return (
    <div className="page-loading" role="status" aria-live="polite">
      Loading…
    </div>
  );
}
